import { css } from 'lit';

export const NotificationsStyle = css`
:host {
  --ix-drawer-border-radius: 0;
  --ix-drawer-padding: 0;
  --ix-drawer-width-sm: 320px;
  --ix-drawer-width-md: 320px;
  --ix-drawer-width-lg: 400px;
}
.destructive-icon {
  color: var(--clr-critical, #DB0028);
  --md-icon-button-icon-color: var(--clr-critical, #DB0028);
  --md-sys-color-on-surface-variant: var(--clr-critical, #DB0028);
}
.destructive-icon path {
  fill: var(--clr-critical, #DB0028);
}
.active-icon {
  color: var(--clr-primary, #1456E0);
  --md-icon-button-icon-color: var(--clr-primary, #1456E0);
  --md-sys-color-on-surface-variant: var(--clr-primary, #1456E0);
}
.active-icon path {
  fill: var(--clr-primary, #1456E0);
}
.inactive-icon {
  color: var(--clr-on-surface, #092241);
  --md-icon-button-icon-color: var(--clr-on-surface, #092241);
  --md-sys-color-on-surface-variant: var(--clr-on-surface, #092241);
  cursor: default;
  opacity: 0.6;
}
.inactive-icon path {
  fill: var(--clr-on-surface, #092241);
  opacity: 0.6;
}
ix-icon-button.sharp {
  --md-icon-font: 'Material Symbols Sharp' !important;
}
.ix-icon-groups {
  --ix-icon-font-size: 32px;
  --ix-icon-line-height: 32px;
}
.ix-icon-groups ix-icon {
  color: var(--clr-on-surface, #092241);
  opacity: 0.6;
}
.ix-icon-groups ix-icon path {
  fill: var(--clr-on-surface, #092241);
}
.filter-dropdown-content,
.datefilter-dropdown-content {
  position: absolute;
  right: 5%;
  top: 3rem;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 3;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px;
  background-color: var(--clr-surface-container-lowest, #fff);
}
.unread {
  font-family: var(--root-primary-font, 'sans-serif');
  padding: 0 5px;
  font-size: var(--text-caption-size, 0.75rem);
  line-height: var(--text-caption-line-height, 1.33333333em);
  left: 22px;
  top: 0;
  background: var(--clr-critical, #db0028);
  letter-spacing: var(--text-caption-letter-spacing, 0.03333333em);
}
.notification-tooltip {
  background-color: var(--cp-neutral-blue-4, #040d19);
  white-space: nowrap;
  font-size: var(--text-caption-size, 0.75rem);
  z-index: 9999;
  color: var(--clr-on-secondary, white);
}
.notification-modal-title,
.notification-modal-subtitle {
  color: var(--clr-on-surface, #092241);
  font-family: var(--root-secondary-font, 'sans-serif');
}
.notification-modal-subtitle {
  font-size: var(--text-heading-size, 1.25rem);
  line-height: var(--text-heading-line-height, 1.2em);
}
.notification-modal-content {
  display: inline-grid;
  grid-template-columns: fit-content(183px) 1fr;
  grid-template-rows: auto auto;
  grid-column-gap: 24px;
  grid-row-gap: 8px;
  font-family: var(--root-primary-font, 'sans-serif');
  font-size: var(--text-default-size, 16px);
  line-height: 28px;
  width: 560px;
  padding-bottom: 16px;
  color: var(--clr-on-surface, #092241);
}
.notification-modal-content-title {
  width: 183px;
  color: var(--clr-on-surface-variant, #092241B3);
}
.notification-modal-subject-title {
  grid-area: 1 / 1 / 2 / 2;
}
.notification-modal-subject-text {
  grid-area: 1 / 2 / 2 / 3;
}
.notification-modal-created-date-title {
  grid-area: 2 / 1 / 3 / 2;
}
.notification-modal-created-date-text {
  grid-area: 2 / 2 / 3 / 3;
}
.notification-modal-site-title {
  grid-area: 3 / 1 / 4 / 2;
}
.notification-modal-site-text {
  grid-area: 3 / 2 / 4 / 3;
}
`;